import axios from "axios";
import {errorToast} from "@/composables/useToasts";

/**
 * Runs the 3DS challenge for the payment intent returned with a 402 response.
 *
 * Resolves once the challenge has settled, so callers can hold a loading state for its duration.
 * The callback receives the Stripe result, so callers can tell a completed payment from a failed one.
 */
export const handle3dSecure = async (error, callback) => {
  if (error.value?.response?.status !== 402) {
    return;
  }

  const {paymentIntent} = error.value.response.data;

  const result = await window.stripeInstance.confirmCardPayment(paymentIntent.clientSecret, {
    payment_method: paymentIntent.paymentMethod,
  });

  if (result.error) {
    axios.get('/stripe/payment-verification-failed');

    errorToast('We were unable to verify your payment for this website, please try again later.');
  }

  await callback(result);
};
